import Box from "@mui/material/Box";
import {  Grid, TextField, Typography } from "@mui/material";
import AppButton from "../../common/AppButton";
import { useAppDispatch,  } from "../../../app/hooks";
import { addSupplierInitialValues } from "../../forms/initialValues";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { editSupplier } from "../../../features/supplier/supplierSlice";
import { useEffect, useState } from "react";
import React from "react";

interface IProps {
  handleClose: () => void;
  setOpenSnackbar: () => void;
  getSupplier: () => void;
  supplier?: any;
  item: any;
}
const EditSupplierModal = ({
  supplier,
  handleClose,
  getSupplier,
  setOpenSnackbar,
  item,
}: IProps) => {
  const dispatch = useAppDispatch();
  const [supplierId, setSupplierId] = useState<any>(item ? item?.id : "");
  const [test, setTest] = useState(addSupplierInitialValues);

  const [supplierName, setSupplierName] = useState<any>(
    item ? item?.supplier_company_name : ""
  );
  const [contactPerson, setContactPerson] = useState<any>(
    item ? item?.contact_person : ""
  );
  const [supplierEmail, setSupplierEmail] = useState<any>(
    item ? item?.email : ""
  );
  const [supplierPhoneNo, setSupplierPhoneNo] = useState<any>(
    item ? item?.phone_number : ""
  );
  const [errorMessages, setErrorMessages] = React.useState({
    supplierName: "",
    supplierPhoneNo: "",
    contactPerson: "",
  });

  const pharmacyId = localStorage?.getItem("pharmacyId");
  useEffect(() => {
    setTest({
      pharmacy_id: pharmacyId,
      supplier_id: supplier?.id,
      supplier_name: supplier?.supplier_company_name,
      contact_person: supplier?.contact_person,
      phone_number: supplier?.phone_number,
      email: supplier?.email,
    });
  }, [supplier]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setTest({
      ...test,
      [name]: value,
    });
  };

  const handleInputChange1 = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSupplierName(e.target.value);
  };
  const handleInputChange2 = (e: React.ChangeEvent<HTMLInputElement>) => {
    setContactPerson(e.target.value);
  };
  const handleInputChange3 = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSupplierPhoneNo(e.target.value);
  };
  const handleInputChange4 = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSupplierEmail(e.target.value);
  };

  const handleSubmit = async (values: any) => {
    setErrorMessages({
      supplierName: "",
      supplierPhoneNo: "",
      contactPerson: "",
    });

    let hasError = false;
    let errors: any = {};

    if (!supplierName) {
      errors.supplierName = "Supplier name is required.";
      hasError = true;
    }
    if (!supplierPhoneNo) {
      errors.supplierPhoneNo = "Phone number is required.";
      hasError = true;
    }
    if (!contactPerson) {
      errors.contactPerson = "Contact person is required.";
      hasError = true;
    }

    // If there are errors, set them in state and return early
    if (hasError) {
      setErrorMessages(errors);
      return;
    }

    const pharmacyId = localStorage.getItem("pharmacyId");
    const supplier: any = {
      supplier_name: supplierName,
      contact_person: contactPerson,
      phone_number: supplierPhoneNo,
      email: supplierEmail,
      pharmacy_id: pharmacyId,
      supplier_id: supplierId,
    };
    try {
      const res = await dispatch(editSupplier(supplier));
      if (res?.payload?.success === true) {
        getSupplier();
        setOpenSnackbar();
        handleClose();
      } else {
        window.alert("Failed to update Supplier. Please try again.");
      }
    } catch (error) {
      console.error("Error adding Supplier: ", error);
    }
  };

  return (
    <Formik
      initialValues={test}
      //validationSchema={editSupplierValidationSchema}
      onSubmit={handleSubmit}
    >
      <Form>
        <Box sx={{ mt: 0.5 }}>
          <Grid container spacing={2}>
            {/* Supplier Name/Company Field */}
            <Grid item xs={12} sm={4}>
              <Typography variant="h6" gutterBottom>
                Supplier Name/Company
              </Typography>
              <Field
                as={TextField}
                fullWidth
                variant="outlined"
                name="supplier_name"
                placeholder="Supplier name"
                value={supplierName}
                onChange={handleInputChange1}
                inputProps={{ style: { padding: "10px 12px" } }}
              />
              <div style={{ color: "red", fontSize: "14px", marginTop: "5px" }}>
                {errorMessages.supplierName && (
                  <span className="error">{errorMessages.supplierName}</span>
                )}
              </div>
            </Grid>

            {/* Contact Person Field */}
            <Grid item xs={12} sm={4}>
              <Typography variant="h6" gutterBottom>
                Contact Person
              </Typography>
              <Field
                as={TextField}
                fullWidth
                variant="outlined"
                name="contact_person"
                placeholder="contact person name"
                value={contactPerson}
                onChange={handleInputChange2}
                inputProps={{ style: { padding: "10px 12px" } }}
              />
              <div style={{ color: "red", fontSize: "14px", marginTop: "5px" }}>
                {errorMessages.contactPerson && (
                  <span className="error">{errorMessages.contactPerson}</span>
                )}
              </div>
            </Grid>

            {/* Phone# Field */}
            <Grid item xs={12} sm={4}>
              <Typography variant="h6" gutterBottom>
                Phone#
              </Typography>
              <Field
                as={TextField}
                fullWidth
                variant="outlined"
                name="phone_number"
                placeholder="03xx xxxxxxx"
                value={supplierPhoneNo}
                onChange={handleInputChange3}
                inputProps={{ style: { padding: "10px 12px" } }}
              />
              <div style={{ color: "red", fontSize: "14px", marginTop: "5px" }}>
                {errorMessages.supplierPhoneNo && (
                  <span className="error">{errorMessages.supplierPhoneNo}</span>
                )}
              </div>
            </Grid>

            {/* Email Field */}
            <Grid item xs={12} sm={4}>
              <Typography variant="h6" gutterBottom>
                Email
              </Typography>
              <Field
                as={TextField}
                fullWidth
                variant="outlined"
                name="email"
                placeholder="Enter email"
                value={supplierEmail}
                onChange={handleInputChange4}
                inputProps={{ style: { padding: "10px 12px" } }}
              />
              {/* <ErrorMessage name="email" component="div" /> */}
            </Grid>
          </Grid>
        </Box>
        <Box sx={{ mt: 0 }}>
          <AppButton
            variant="contained"
            color="primary"
            type="submit"
            title="Update"
            sx={{ float: "right" }}
          />
        </Box>
      </Form>
    </Formik>
  );
};

export default EditSupplierModal;
